import { equals2au1ep9vhcato as equals } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  Assign2jm8flaivtcon as Assign,
  IfNotNull38wuwth0boumg as IfNotNull,
  OnFielduegjwkreacmm as OnField,
  Chain19a4phelb7wvt as Chain,
} from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/Modification.mjs';
import { nullElement39ujy5fzowmto as nullElement } from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import {
  get_serializableProperties1162nosnaangd as get_serializableProperties,
  SerializableProperty3cbm268cpjr8q as SerializableProperty,
} from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializableProperty.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function modification(serializer, old, new_0) {
  // Inline function 'kotlin.run' call
  var tmp$ret$1;
  $l$block_0: {
    if (equals(old, new_0)) {
      tmp$ret$1 = null;
      break $l$block_0;
    }
    if (old == null || new_0 == null) {
      tmp$ret$1 = Assign().new_com_lightningkite_services_database_Modification_Assign_1ypiqt_k$(new_0);
      break $l$block_0;
    }
    var tmp0_elvis_lhs = nullElement(serializer);
    var tmp1_safe_receiver = get_serializableProperties(tmp0_elvis_lhs == null ? serializer : tmp0_elvis_lhs);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$8;
        $l$block_1: {
          if (!isInterface(element, SerializableProperty()))
            THROW_CCE();
          var oldValue = element.get_g4cbzo_k$(old);
          var newValue = element.get_g4cbzo_k$(new_0);
          var tmp0_safe_receiver = modification(element.get_serializer_u29zhh_k$(), oldValue, newValue);
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp_1;
            var tmp_2;
            if (element.get_serializer_u29zhh_k$().get_descriptor_wjt6a0_k$().get_isNullable_67sy7o_k$()) {
              tmp_2 = !(tmp0_safe_receiver instanceof Assign());
            } else {
              tmp_2 = false;
            }
            if (tmp_2) {
              tmp_1 = IfNotNull().new_com_lightningkite_services_database_Modification_IfNotNull_mgiwu9_k$(tmp0_safe_receiver);
            } else {
              tmp_1 = tmp0_safe_receiver;
            }
            tmp_0 = tmp_1;
          }
          var tmp1_elvis_lhs = tmp_0;
          var tmp_3;
          if (tmp1_elvis_lhs == null) {
            tmp$ret$8 = null;
            break $l$block_1;
          } else {
            tmp_3 = tmp1_elvis_lhs;
          }
          var inner = tmp_3;
          tmp$ret$8 = OnField().new_com_lightningkite_services_database_Modification_OnField_3hlyhh_k$(element, inner);
        }
        var tmp0_safe_receiver_0 = tmp$ret$8;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination.add_utx5q5_k$(tmp0_safe_receiver_0);
        }
      }
      tmp = Chain().new_com_lightningkite_services_database_Modification_Chain_qdmx0f_k$(destination);
    }
    var tmp2_elvis_lhs = tmp;
    tmp$ret$1 = tmp2_elvis_lhs == null ? Assign().new_com_lightningkite_services_database_Modification_Assign_1ypiqt_k$(new_0) : tmp2_elvis_lhs;
  }
  return tmp$ret$1;
}
//region block: exports
export {
  modification as modification1bed5xcrmg3fq,
};
//endregion

//# sourceMappingURL=modification.diff.mjs.map
